{
  "slug": "iq-score-ranges-explained",
  "title": "智商分数范围解释",
  "description": "探索常见的智商分数带、近似百分比、置信区间和标签的限制。",
  "summary": "智商分数范围是方便的总结,但边界和标签因测试而异,分数应该作为估计值并在上下文中解释。",
  "sections": [
    {
      "heading": "常见范围的实用指南",
      "paragraphs": [
        "对于一个平均值为 的尺度 100 标准偏差 15,这些带提供了一般的定向,而不是诊断类别。"
      ],
      "bullets": [
        "130 以上:大约顶部 2%",
        "120–129: 约为 的 911998年12月31日终了的两年期收入和支出及准备金和基金结余变动表97百分比",
        "110–119: 约为 的 75四90百分比",
        "90–109: 宽中间范围",
        "80–89: 约为 的 9四24百分比",
        "70–79: 约为 的 2二十四8百分比",
        "下方 70: 约为最低 2%"
      ]
    },
    {
      "heading": "为什么标签不同",
      "paragraphs": [
        "出版商和研究机构使用不同的术语和截止值,边界上的结果与距离一点的结果没有显著差异,置信区间通常跨越一个以上的带。",
        "专业人士在相关情况下会考虑适应性功能、发展、教育和语言,并且会根据学生的特点和能力来判断是否需要进行辅导。"
      ]
    },
    {
      "heading": "阅读配置文件,而不仅仅是数字",
      "paragraphs": [
        "两个人总分相同,但能力不同。 一个人在语言推理方面表现优异,而另一个人在视觉模式方面表现优异。 复合分数可以掩盖这些差异。",
        "使用在线乐谱作为特定条件下的快照,而不是永久标签。"
      ]
    }
  ],
  "faqs": [
    {
      "question": "什么是高智商?",
      "answer": "在许多尺度上, 120 以上是远高于平均值和 130 或者以上是顶部的周围. 2百分比，但术语各不相同。"
    },
    {
      "question": "智商范围的界限是否准确?",
      "answer": "测量误差和不同的分类系统使边界是近似的。"
    }
  ],
  "related": [
    "what-is-the-average-iq",
    "what-does-an-iq-of-120-mean",
    "what-does-an-iq-of-140-mean"
  ]
}
